var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGrid } from '../elements/data-grid';
import { DataGridCell } from '../elements/data-grid-cell';
import { DataGridRow } from '../elements/data-grid-row';
import { DataGridHeadCell } from '../elements/data-grid-head-cell';
import { MarkdownContent } from '../elements/markdown-content';
import { useLang } from '../hooks/use-lang';
import { includes } from 'lodash';
import { EntityValue } from './entity-value';
import { ContentNode } from './content-node';
import { useManagement } from '../hooks/use-management';
import { EntityTypeSelect } from '../select/entity-type-select';
import { useEntityMutation } from '../hooks/use-entity-mutation';
import { Checkbox } from '../elements/checkbox';
var cls = classNames('entity-data-grid');
export var EntityDataGridDefaultProps = {
  items: [],
  showFoot: true,
  colors: {
    border: 'transparent',
    hover: {
      border: 'transparent'
    },
    active: {
      border: 'transparent'
    },
    focus: {
      border: 'transparent'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-height: 60vh;\n    \n  "], ["\n    max-height: 60vh;\n    \n  "])))
});
var CellStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
var SelectsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
var RowStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var TooltipContentStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntityMultiValueStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n  "], ["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n  "])), theme.UNIT(4))
});
var EntityValueStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n  "], ["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n    user-select: none;\n  "], ["\n    ", "\n    user-select: none;\n  "])), function (_a) {
    var isEmpty = _a.isEmpty;
    return isEmpty && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('text-very-subtle'));
  })
});
var FootContentStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    user-select: none;\n    display: flex;\n    margin-top: 2px;\n    padding-left: 2px;\n    font-weight: 500;\n    color: inherit;\n  "], ["\n    user-select: none;\n    display: flex;\n    margin-top: 2px;\n    padding-left: 2px;\n    font-weight: 500;\n    color: inherit;\n  "])))
});
var CheckboxStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityDataGrid',
  Container: styled(DataGrid)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Row: styled(DataGridRow)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Cell: styled(DataGridCell)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Selects: styled(EntityTypeSelect)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), SelectsStyles),
  HeadCell: styled(DataGridHeadCell)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Content: styled(ContentNode)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  EntityValue: styled(EntityValue)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  EntityMultiValue: styled(EntityValue)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), EntityMultiValueStyles),
  TooltipContent: styled(MarkdownContent)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), TooltipContentStyles),
  Checkbox: styled(Checkbox)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles),
  FootContent: styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), FootContentStyles)
};
export var EntityDataGrid = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityDataGridDefaultProps, props);
  var className = componentProps.className,
    items = componentProps.items,
    defn = componentProps.defn,
    showFoot = componentProps.showFoot,
    showBorder = componentProps.showBorder,
    onAddClick = componentProps.onAddClick,
    onRemoveClick = componentProps.onRemoveClick,
    colors = componentProps.colors;
  var _a = __read(React.useState({}), 2),
    selectedItemsMap = _a[0],
    setSelectedItemsMap = _a[1];
  var _b = __read(React.useState({}), 2),
    editingCells = _b[0],
    setEditingCells = _b[1];
  var getCellKey = function (rowId, fieldName) {
    return "".concat(rowId, "_").concat(fieldName);
  };
  var itemsType = entityTypeNameFor(items[0]);
  var _c = useEntityMutation({
      type: 'Update',
      entityTypeName: itemsType,
      fields: []
    }),
    submitUpdate = _c.submit,
    updateLoading = _c.loading,
    updateError = _c.error;
  var updateLinkedJunctionField = function (entityId, fieldName, newValue) {
    return __awaiter(void 0, void 0, void 0, function () {
      var input, e_1;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            input = (_a = {}, _a[fieldName] = newValue, _a);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4 /*yield*/, submitUpdate({
              variables: {
                id: entityId,
                input: input
              }
            })];
          case 2:
            _b.sent();
            return [3 /*break*/, 4];
          case 3:
            e_1 = _b.sent();
            console.error("Error updating expertise field", e_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleCellAction = function (cellKey, action, rowItem, fieldName) {
    var _a;
    if (action === 'edit') {
      setEditingCells(function (prev) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[cellKey] = true, _a));
      });
    } else if (action === 'confirm' || action === 'cancel') {
      setEditingCells(function (prev) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[cellKey] = false, _a));
      });
      if (action === 'confirm') {
        var selectedValue = (_a = selectedItemsMap[rowItem.id]) === null || _a === void 0 ? void 0 : _a[fieldName];
        // Use explicit type check to extract id if available, otherwise use the raw value.
        var minimalValue = Array.isArray(selectedValue) ? selectedValue.map(function (item) {
          return item.id;
        }) : typeof selectedValue === 'object' && selectedValue !== null ? selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.id : selectedValue;
        updateLinkedJunctionField(rowItem.id, fieldName, minimalValue);
      }
    }
  };
  var handleCellChanges = function (entityId, fieldName, items) {
    // need to update the selectedItemsMap with the new items
    setSelectedItemsMap(function (prev) {
      var _a, _b;
      var newState = __assign(__assign({}, prev), (_a = {}, _a[entityId] = __assign(__assign({}, prev[entityId] || {}), (_b = {}, _b[fieldName] = items, _b)), _a));
      return newState;
    });
  };
  var manage = useManagement();
  var t = useLang();
  return React.createElement(My.Container, {
    showBorder: showBorder,
    className: cls.name(className),
    head: defn.formFields.map(function (field, index) {
      var description = manage.isOwn ? field.ownDescription || field.description : field.description;
      return React.createElement(My.HeadCell, {
        isLast: index === defn.formFields.length - 1,
        id: field.name,
        key: index,
        tooltip: description && React.createElement(My.TooltipContent, {
          text: description
        })
      }, field.label);
    }),
    footOnClick: onAddClick,
    footColSpan: defn.formFields.length,
    foot: showFoot && React.createElement(My.FootContent, null, t(items.length ? "".concat(defn.createAnotherLabel || 'Add More', " ...") : "".concat(defn.createLabel || 'Add', " ...")))
  }, items.map(function (rowItem, rowIndex) {
    return React.createElement(My.Row, {
      key: rowIndex,
      onButtonAction: function (action, event) {
        return onRemoveClick ? onRemoveClick(rowItem, event) : null;
      }
    }, defn.formFields.map(function (field, colIndex) {
      var itemDictionary = rowItem;
      var value = itemDictionary[field.name];
      var cellKey = getCellKey(rowItem.id, field.name);
      var isEditing = editingCells[cellKey] === true;
      var isLogo = includes(['Organisation'], field.entityTypeName);
      var slelectedItems = selectedItemsMap[rowItem.id] && field.name in selectedItemsMap[rowItem.id] ? selectedItemsMap[rowItem.id][field.name] : value;
      return React.createElement(My.Cell, {
        isLast: colIndex === defn.formFields.length - 1,
        key: colIndex,
        onButtonAction: function (action, event) {
          return handleCellAction(cellKey, action, rowItem, field.name);
        }
      }, isEditing ? React.createElement(React.Fragment, null, value && field.type === 'linkedMultiple' && !!value.length &&
      // Render a single select for the entire linkedMultiple array.
      React.createElement(My.Selects, {
        key: "".concat(colIndex, "-linkedMultiple"),
        entityTypeName: entityTypeNameFor(value[0]),
        selectedItems: slelectedItems,
        onSelect: function (_a) {
          var items = _a.items;
          // update selected items while editing
          handleCellChanges(rowItem.id, field.name, items);
        },
        optionMenuInputProps: {
          bodyProps: {
            colors: colors
          }
        }
      }), value && field.type === 'linked' && React.createElement(My.Selects, {
        key: "".concat(colIndex, "-linked"),
        entityTypeName: entityTypeNameFor(value),
        allowMultipleSelections: false,
        selectedItem: slelectedItems,
        onSelect: function (_a) {
          var item = _a.item;
          handleCellChanges(rowItem.id, field.name, item);
        },
        optionMenuInputProps: {
          bodyProps: {
            colors: colors
          }
        }
      }), field.formFieldType === 'boolean' && React.createElement(My.Checkbox, {
        id: "".concat(rowItem.id, "-").concat(field.name),
        checked: slelectedItems,
        // value={slelectedItems}
        size: 24,
        onChange: function (newValue) {
          handleCellChanges(rowItem.id, field.name, newValue);
        }
      })) : React.createElement(React.Fragment, null, value && field.type === 'linkedMultiple' && !!value.length &&
      // Display mode remains as-is: map each item for presentation.
      value.map(function (item) {
        return React.createElement(My.EntityMultiValue, {
          key: item.id,
          showImageBorder: isLogo,
          imageStyle: isLogo ? 'logo' : 'default',
          variant: 'card',
          entity: item
        });
      }), value && field.type === 'linked' && React.createElement(My.EntityValue, {
        showImageBorder: isLogo,
        imageStyle: isLogo ? 'logo' : 'default',
        variant: 'card',
        entity: value
      }), field.formFieldType === 'boolean' && (value ? t('Yes') : t('No'))), value && field.type === 'longText' &&
      // <My.Content isEmpty={!value?.text} entity={value?.text ? value : { text: '(none)' }} />
      React.createElement(React.Fragment, null, "Coming soon"));
    }));
  }));
};
EntityDataGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;